<template>
  <!-- :nudge-width="400" -->
  <v-menu
    v-model="menu"
    :close-on-content-click="false"
    rounded
    :nudge-top="19"
  >
    <template v-slot:activator="{ on, attrs }">
      <div class="icon-wrapper">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              v-bind="attrs"
              v-on="on"
              @click.stop="viewRecord(node, selectedRecord)"
            >
              <v-icon small>mdi-eye</v-icon>
            </v-btn>
          </template>
          <span>Show this node</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              v-bind="attrs"
              v-on="on"
              @click.stop="
                addDataToRecord(
                  node,
                  selectedRecord,
                  new Date(currentRecordDateTimeStamp)
                )
              "
            >
              <v-icon small>mdi-pencil-plus</v-icon>
            </v-btn>
          </template>
          <span>Add a value to this category and any children</span>
        </v-tooltip>

        <v-btn
          icon
          small
          class="mr-2"
          v-bind="attrs"
          v-on="on"
          @click="clearMenuFlags()"
        >
          <v-icon>mdi-dots-vertical</v-icon>
        </v-btn>
      </div>
    </template>

    <v-card flat>
      <v-list>
        <v-list-item>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                text
                v-bind="attrs"
                v-on="on"
                @click="toggleMenuFlag('date')"
              >
                <v-icon>mdi-calendar-edit</v-icon>
              </v-btn>
            </template>
            <span>Add data at a specific date/time</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                text
                v-bind="attrs"
                v-on="on"
                @click.stop="toggleMenuFlag('add')"
              >
                <v-icon>mdi-plus</v-icon>
              </v-btn>
            </template>
            <span>Add categories to the tree</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                text
                v-bind="attrs"
                v-on="on"
                v-if="isGraphable && node.value.length > 3"
                @click="viewGraph(node, selectedRecord)"
              >
                <v-icon>mdi-chart-line</v-icon>
              </v-btn>
            </template>
            <span>View as a graph</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                text
                v-bind="attrs"
                v-on="on"
                @click="toggleMenuFlag('remove')"
              >
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </template>
            <span>Remove this category</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                text
                v-bind="attrs"
                v-on="on"
                @click="toggleMenuFlag('edit')"
              >
                <v-icon>mdi-cog</v-icon>
              </v-btn>
            </template>
            <span>Edit this category</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                text
                v-bind="attrs"
                v-on="on"
                @click="toggleMenuFlag('replaceInPlace')"
              >
                <v-icon>mdi-file-replace-outline</v-icon>
              </v-btn>
            </template>
            <span>Replace this category with a new one.</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                text
                v-bind="attrs"
                v-on="on"
                @click="toggleMenuFlag('cloneCategory')"
              >
                <v-icon>mdi-numeric-2-box-multiple-outline</v-icon>
              </v-btn>
            </template>
            <span>Duplicate this category.</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                text
                v-bind="attrs"
                v-on="on"
                @click="toggleMenuFlag('event')"
              >
                <v-icon>mdi-clipboard-edit-outline</v-icon>
              </v-btn>
            </template>
            <span>Add this category to an Event</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                text
                v-bind="attrs"
                v-on="on"
                @click="toggleMenuFlag('showSaveForm')"
              >
                <v-icon>mdi-content-save-move-outline</v-icon>
              </v-btn>
            </template>
            <span>Save this category tree as a form</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn text v-bind="attrs" v-on="on" @click="scoreCat()">
                <v-icon>mdi-format-list-numbered-rtl</v-icon>
              </v-btn>
            </template>
            <span>Score this category and its children, if applicable</span>
          </v-tooltip>
        </v-list-item>
      </v-list>
      <v-divider></v-divider>

      <!-- ***** Add ***** -->
      <v-dialog v-if="add" v-model="add" width="600px" persistent>
        <AddCategories
          :categories="names"
          :selectedRecord="selectedRecord"
          :nodeName="node.name"
          :nodeId="node._id"
          @cancel-add-dialog="add = !add"
          @close-add-dialog="
            add = !add;
            menu = false;
          "
        ></AddCategories>
      </v-dialog>

      <!-- ***** EDIT ***** -->
      <v-dialog v-if="edit" v-model="edit" width="600px" persistent>
        <EditCategory
          :node="node"
          :selectedRecord="selectedRecord"
          @cancel-edit-dialog="edit = !edit"
        />
      </v-dialog>

      <!-- ***** Date/time entry ***** -->
      <v-dialog v-if="date" v-model="date" width="600px" persistent>
        <div class="d-flex flex-row menu-background">
          <div class="d-flow flow-column">
            <v-date-picker
              v-model="pickerDate"
              no-title
              scrollable
              show-adjacent-months
              :max="today"
            ></v-date-picker>
            <div class="text-center">
              <v-btn text color="secondary" @click="date = false">
                Cancel
              </v-btn>
              <v-btn
                text
                color="primary"
                @click="addValuesFromDatepicker(pickerDate, pickerTime)"
              >
                OK
              </v-btn>
            </div>
          </div>
          <v-spacer></v-spacer>
          <v-time-picker
            v-model="pickerTime"
            scrollable
            ampm-in-title
            format="ampm"
            :allowed-minutes="[0, 15, 30, 45]"
          ></v-time-picker>
        </div>
      </v-dialog>

      <!-- ***** Delete ***** -->
      <span v-if="remove" class="mt-1">
        <v-card-actions class="justify-space-between">
          <v-btn color="grey" outlined dark @click="remove = !remove">
            cancel
          </v-btn>
          <v-btn color="#D32F2F" dark @click="removeNode()">Remove</v-btn>
        </v-card-actions>
      </span>
      <!-- ***** Save as Form ***** -->
      <span v-if="showSaveForm" class="mt-1">
        <v-card-actions class="justify-space-between">
          <v-text-field
            class="mx-3"
            label="Saved form name"
            v-model="savedFormName"
            hint="Save this category tree as a form"
            required
            :rules="[() => !!savedFormName || 'A form name is required']"
          ></v-text-field>
          <span>
            <v-btn
              color="grey"
              outlined
              @click="showSaveForm = !showSaveForm"
              class="mr-2"
            >
              cancel
            </v-btn>
            <v-btn
              color="primary"
              @click="saveTree()"
              :disabled="!savedFormName"
            >
              Save
            </v-btn>
          </span>
        </v-card-actions>
      </span>
      <!-- ***** Clone node ***** -->
      <span v-if="cloneCategory" class="mt-1">
        <v-card-actions class="justify-space-between">
          <v-btn
            color="grey"
            outlined
            @click="cloneCategory = !cloneCategory"
            class="mr-2"
          >
            cancel
          </v-btn>
          <v-btn color="#D32F2F" dark @click="cloneTree()">
            Duplicate
          </v-btn>
        </v-card-actions>
      </span>
      <!-- ***** Replace In Place ***** -->
      <v-dialog
        v-if="replaceInPlace"
        v-model="replaceInPlace"
        width="600px"
        persistent
      >
        <ReplaceCategory
          :node="node"
          :selectedRecord="selectedRecord"
          @cancel-edit-dialog="replaceInPlace = !replaceInPlace"
        />
      </v-dialog>
      <!-- ***** Edit Event ***** -->
      <div v-if="event" class="mt-1 mx-3">
        <EditEvents
          :node="node"
          :events="events"
          :selectedRecord="selectedRecord"
          :showEventEditControls.sync="event"
        />
      </div>
    </v-card>
  </v-menu>
</template>

<script>
import { mapGetters, mapActions, mapState } from "vuex";

import { strings } from "vuex-store-builder";
import { treePeriodicAdder, treeWalker } from "../../utils/treeUtils";

import { duplicateNodeTreeToRecord } from "../../utils/api";
import { createTemplateFromNode, scoreNode } from "../../utils/api";

import ReplaceCategory from "./record-viewer/ReplaceCategory";
import AddCategories from "./record-viewer/AddCategories";
import EditCategory from "./record-viewer/EditCategory";
import EditEvents from "./EditEvents";

export default {
  name: "Menu",
  props: {
    parentID: String,
    node: Object,
    selectedRecord: Object,
  },

  data: () => ({
    customCat: false,
    categorySelected: false,
    model: null,
    isLoading: false,
    //search: '',
    addData: {
      name: "",
      description: "",
      abbrev: "",
      type: "",
      uom: "",
      min: null,
      max: null,
      precision: null,
      parent: "",
    },
    menu: false,
    message: false,
    hints: true,
    edit: false,
    remove: false,
    add: false,
    date: false,
    event: false,
    isDeleting: false,
    pickerDate: null,
    pickerTime: null,
    showSaveForm: false,
    savedFormName: "",
    replaceInPlace: false,
    cloneCategory: false,
    today: new Date().toISOString(),
  }),
  computed: {
    ...mapState({
      editMode: (state) => state.records.editMode,
      currentRecordDateTimeStamp: (state) =>
        state.records.currentRecordDateTimeStamp,
    }),
    ...mapState(
      "removeNode",
      { deleteNodeFailed: strings.errored("deleteNode") },
      { root: true }
    ),
    ...mapGetters({ dbRecordItem: "getRecordItem" }),
    ...mapGetters("allTypes", { types: "list" }, { root: true }),
    ...mapGetters("allUoms", { units: "list" }, { root: true }),
    ...mapGetters("allRootCats", { names: "list" }, { root: true }),
    ...mapGetters({
      events: "getEventsGroupByRecord",
    }),

    isGraphable() {
      return (
        this.node.meta.type === "numeric" ||
        this.node.meta.type === "numeric-array" ||
        this.node.meta.type === "numeric-scale"
      );
    },
    //selectedCategory: '',
  },
  methods: {
    ...mapActions(["openNewTab"]),
    viewGraph(recordItem, fullRecord) {
      this.openNewTab({
        recordItem,
        fullRecord,
        type: "graph",
        datetime: this.currentRecordDateTimeStamp,
        typeSpecificPayload: null,
      });
    },
    startDrag: (evt, item) => {
      evt.dataTransfer.dropEffect = "move";
      evt.dataTransfer.effectAllowed = "move";
      evt.dataTransfer.setData("itemID", item.id);
    },
    onDrop(evt, list) {
      const itemID = evt.dataTransfer.getData("itemID");
      const item = this.items.find((item) => item.id === itemID);
      item.list = list;
    },
    viewRecord(recordItem, fullRecord) {
      const parsedobj = JSON.parse(JSON.stringify(recordItem));

      this.openNewTab({
        recordItem: parsedobj,
        fullRecord,
        type: "record",
        datetime: this.currentRecordDateTimeStamp,
        typeSpecificPayload: null,
      });
    },
    async addDataToRecord(recordItem, fullRecord, timestamp) {
      await this.openNewTab({
        recordItem,
        fullRecord,
        type: "record",
        datetime: this.currentRecordDateTimeStamp,
        typeSpecificPayload: null,
      });
      this.$root.$emit("menu:edit-record", true, timestamp);
      this.addNewDataToPeriodic(recordItem._id, timestamp);
    },
    toggleEditMode() {
      this.$emit("toggleeditmode", this.node);
    },
    editField() {
      this.edit = !this.edit;
      return;
    },
    async removeNode() {
      this.isDeleting = true;
      const response = await this.$store.dispatch(
        "removeNode/deleteNode",
        this.node._id
      );
      if (!this.deleteNodeFailed.message) {
        this.$store.dispatch("addNotification", {
          type: "success",
          message: `Removed category ${this.node.name}`,
        });
        if (this.node.parent) {
          // This isn't a root node. Just refresh the record and update the vuex store.
          await this.$store.dispatch("updateRecordFromData", response);
        } else {
          // This is a root node. Tell the Record component to reload the root nodes and clear the selected node.
          this.$root.$emit("menu:reload-root-nodes");
        }
        // find any open tabs for this id and remove them
        this.$store.state.records.tabs
          .filter((tab) => {
            return tab.recordItemId === this.node._id;
          })
          .map((tab) => {
            this.$store.dispatch("closeTab", tab);
          });
      } else {
        this.$store.dispatch("addNotification", {
          type: "errorMessage",
          message: `Failed to delete category ${this.node.name}`,
        });
      }
      this.isDeleting = false;
      this.remove = !this.remove;
      this.menu = false;
      return;
    },
    addNewDataToPeriodic(nodeId, timestamp) {
      const node = treeWalker(this.dbRecordItem, nodeId);
      treePeriodicAdder(node, timestamp);
    },
    addValuesFromDatepicker(date, time) {
      const datePieces = date.split("-");
      const timePeices = time.split(":");
      // We have to build the date and time in pieces since otherwise it will default to UTC
      const timestamp = new Date(
        datePieces[0],
        datePieces[1] - 1,
        datePieces[2],
        timePeices[0],
        timePeices[1]
      );
      this.addDataToRecord(this.node, this.selectedRecord, timestamp);
      this.date = false;
      this.menu = false;
    },
    saveTree() {
      const params = {
        node_id: this.node._id,
        template_name: this.savedFormName,
      };

      createTemplateFromNode(params)
        .then((response) => {
          if (response.Success) {
            this.$store.dispatch("addNotification", {
              type: "success",
              message: `Saved category ${this.node.name} tree as ${this.savedFormName}`,
            });
            this.$store.dispatch("allTemplates/templates", { rootState: true });
          } else {
            this.$store.dispatch("addNotification", {
              type: "errorMessage",
              message: `Failed to save category ${this.node.name} tree`,
            });
          }
        })
        .catch((err) => {
          this.$store.dispatch("addNotification", {
            type: "errorMessage",
            message: `Failed to save category ${this.node.name} tree`,
          });
        })
        .finally(() => {
          this.savedFormName = "";
          this.showSaveForm = false;
        });
    },
    async cloneTree() {
      try {
        const response = await duplicateNodeTreeToRecord(this.node._id);
        const { node: newNode, record: newRecord } = response;
        if (newNode && newRecord) {
          this.$store.dispatch("updateRecordFromData", newRecord);
          this.$store.dispatch("addNotification", {
            type: "success",
            message: `Duplicated  ${this.node.name}`,
          });
          this.addDataToRecord(
            newNode,
            this.selectedRecord,
            new Date(this.currentRecordDateTimeStamp)
          );
        } else {
          this.$store.dispatch("addNotification", {
            type: "warning",
            message: `Could not duplicate ${this.node.name}`,
          });
        }
      } catch (err) {
        this.$store.dispatch("addNotification", {
          type: "errorMessage",
          message: `Could not duplicate  ${this.node.name}`,
        });
      }
      this.cloneCategory = false;
      this.menu = false;
    },
    async scoreCat() {
      const response = await scoreNode({
        rec_id: this.selectedRecord._id,
        node_id: this.node._id,
      });
      if (response?.Success) {
        this.$store.dispatch("addNotification", {
          type: "success",
          message: `Scored category ${this.node.name}`,
        });
        this.$store.commit("SET_SCORE_FOR_NODE", {
          node_id: this.node._id,
          score: response.Success.total,
        });
      } else {
        this.$store.dispatch("addNotification", {
          type: "errorMessage",
          message: `Failed to score category ${this.node.name}`,
        });
      }
      this.menu = false;
    },
    toggleMenuFlag(flag) {
      const state = this[flag];
      this.remove = false;
      this.edit = false;
      this.add = false;
      this.date = false;
      this.event = false;
      this.showSaveForm = false;
      this.replaceInPlace = false;
      this.cloneCategory = false;
      this[flag] = !state;
    },
    clearMenuFlags() {
      this.remove = false;
      this.edit = false;
      this.add = false;
      this.date = false;
      this.event = false;
      this.showSaveForm = false;
      this.replaceInPlace = false;
      this.cloneCategory = false;
    },
  },
  watch: {
    search(val) {
      // Items have already been loaded
      if (this.items.length > 0) return;
    },
  },
  components: {
    ReplaceCategory,
    AddCategories,
    EditCategory,
    EditEvents,
  },
};
</script>

<style scoped>
.drop-zone {
  background-color: #eee;
  margin-bottom: 10px;
  padding: 10px;
}

.drag-el {
  background-color: #fff;
  margin-bottom: 10px;
  padding: 5px;
}
.menu-background {
  background-color: #fff;
}
</style>
